<template>
  <div>
    <ASwitch v-model="input" @change="search"/>
  </div>
</template>

<script>
export default {
  name: 'SwitchXTableFilter',
  props: ['value'],
  data() {
    return {
      input: undefined
    }
  },
  methods: {
    search() {
      this.$emit('input', this.input)
    },
  },
  mounted() {
    this.input = this.value
  }
}
</script>
